import request from '@/utils/axios'
import {cu} from '../common'

let base = '/backend/interfacemanage'
let h5Base = '/backend/check'

/**
 * 获取企业应用信息
 */
export const getCorpAppInfo = () => {
  return request({
    url: `${base}${cu}/app/getCorpAppInfo`,
    method: 'get'
  })
}

/**
 * 获取企业应用信息(H5应用)
 */
export const getCorpH5AppInfo = () => {
  return request({
    url: `${h5Base}${cu}/app/getCorpAppInfo`,
    method: 'get'
  })
}

/**
 * 根据devid查询当前企业的应用
 * @param devid
 */
export const findCorpAppInfo = (devid) => {
  return request({
    url: `${base}${cu}/app/findCorpAppInfo?devid=${devid}`,
    method: 'get'
  })
}

// ------------------------------------

/**
 * 查询应用概览
 */
export const getCorporationAppTotal = devid => {
  return request({
    url: `${h5Base}${cu}/app/getCorporationAppTotal?devid=${devid}`,
    method: 'get'
  })
}

/**
 * 查询企业概览
 */
export const getCorporationTotal = () => {
  return request({
    url: `${h5Base}${cu}/app/getCorporationTotal`,
    method: 'get'
  })
}

/**
 * 获取充值记录
 * @param params
 * @param corpNo
 */
export const getRechargeRecord = (params, corpNo) => {
  return request({
    url: `${base}${cu}/app/rechargeRecordList/${corpNo}`,
    method: 'post',
    data: params
  })
}

/**
 * 获取消费记录
 * @param params
 * @param corpNo
 */
export const getChargeRecord = (params, corpNo) => {
  return request({
    url: `${base}${cu}/app/consumeRecordList/${corpNo}`,
    method: 'post',
    data: params
  })
}

/**
 * 获取企业费用统计数据
 */
 export const getCorpCostStatistics = () => {
  return request({
    url: `${base}${cu}/corp/getCorpCostStatistics`,
    method: 'get'
  })
}

/**
 * 获取企业费用（消费、充值）各年月的统计数据
 */
 export const getCorpCostStatisticsChartData = (params) => {
  return request({
    url: `${base}${cu}/corp/getCorpCostStatisticsChartData`,
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/corporation/app.js